module.exports = __webpack_public_path__ + "static/media/email.74183d3b.png";